import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSynoptic = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2.5,
	strokeLinecap: "round",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3 6H21M3 18H21M15 6L9 18" })
});
export default SvgSynoptic;
